import React from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import Button1 from '../general/button1';

import "./replay-content-ui.css"

class ReplayContentUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'rewind',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/rewind.svg'
			}
		];
	}
}

export const replayContentUICaching = new ReplayContentUICaching();

const ReplayContentUI = (props: ReplayContentUIConfig) => {

	return (
		<div className="modal-disable-select center-element replay-content-ui-container" style={{
		}}>
			<Button1 props={{
				width: '100%',
				height: '100%',
				onClick: props.onReplayContentClicked,
				buttonText: 'Replay Content',
				hoverColor: constants.design.hoverColor2,
				imgSrc: replayContentUICaching.getItemByKey('rewind').src,
				alt508: '',
				imgOnRight: true,
				imgWidth: '13%',
				imgRight: '20px',
				imgTextLeft: '-30px'
			}} ></Button1>
		</div>
	);

};

export interface ReplayContentUIConfig extends BaseConfig {
	onReplayContentClicked: () => void;
}

export default ReplayContentUI;